import { Corporate } from "../../../db_access/corporate";
import OrganizationalComparison from "../../../organizational-pages/OrganizationalComparison";

const CorporateComparison = () => {
  return <OrganizationalComparison Org={Corporate} />;
};

export default CorporateComparison;
